const url = process.env.REACT_APP_API_URL;

module.exports = {
  baseURL:url,
  // baseURL: "https://evaluationapi.dlps.co.in/api/",
  // baseURL:"https://dekhooo.com/api/",
  // baseURL: "https://api.dlws.edu.in/",
  // baseURL:"https://teacher-evaluation-system-t4rh.onrender.com/api",
  UserRole: ["Superadmin", "Observer", "Teacher"],
};
